import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const FALLBACK = {};
const ExternalDataContext = createContext(void 0);
const ExternalDataProvider = ({
  children,
  externalData
}) => {
  return /* @__PURE__ */ jsx(ExternalDataContext.Provider, { value: externalData ?? FALLBACK, children });
};
function useExternalData() {
  const context = useContext(ExternalDataContext);
  if (context === void 0) {
    throw new Error(
      "useExternalData must be used within a ExternalDataProvider"
    );
  }
  return context;
}
export {
  ExternalDataProvider,
  useExternalData
};
//# sourceMappingURL=external-data-context.js.map
